export function normalizeImageUrl (url) {
  const value = String(url || '').trim()
  if (!value) return ''
  if (/^https?:\/\//i.test(value)) return value
  if (/^\/\//.test(value)) return `${window.location.protocol}${value}`
  if (value.charAt(0) === '/') return value
  return `/${value}`
}
